
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/request-a-return",
      function () {
        return require("private-next-pages/request-a-return/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/request-a-return"])
      });
    }
  